import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/login';
import ModalDadosLogin from './components/modalDadosLogin';
import ModalErro from './components/modalErro';
import Video from './components/video';
import ModalVideoUnavailable from "./components/modalVideoUnavailable";
import Loader from "./components/loader";
import useTheme from './hooks/useTheme';


function App({ testErrorModal }) {
    const [showVideo, handleConfirm] = useState(false);
    const [showModal, handleModal] = useState(false);
    const [videoUrl, handleUrl] = useState("");
    const [credit, handleCredit] = useState ("");
    const [creditTemplate, handleCreditTemplate] = useState ("");
    const [locution, handleLocution] = useState ("");
    const [showModalErro, handleModalErro] = useState(false);
    const [showModalVideoUnavailable, handleModalVideoUnavailable] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const { getThemeClass } = useTheme();


    useEffect(() => {
        if (testErrorModal) {
            handleModalErro(true);
        }
    }, [testErrorModal]);

    return (
        <div>
            <div  className={getThemeClass('header')} onClick={() => window.location.replace(window.location.href)}></div>
            { showVideo ? <Video videoUrl={videoUrl} credit={credit} creditTemplate={creditTemplate} locution={locution} /> : <Login handleConfirm={handleConfirm} handleModal={handleModal} handleUrl={handleUrl} handleCredit={handleCredit} handleCreditTemplate={handleCreditTemplate} handleLocution={handleLocution} handleModalErro={handleModalErro} handleModalVideoUnavailable={handleModalVideoUnavailable} setShowLoader={setShowLoader} />}
            { showModal ? <ModalDadosLogin handleModal={handleModal} /> : <span style={{ "display": "none" }}></span>}
            { showModalErro ? <ModalErro handleModalErro={handleModalErro} /> : <span style={{ "display": "none" }}></span>}
            { showModalVideoUnavailable ? <ModalVideoUnavailable handleModalVideoUnavailable={handleModalVideoUnavailable} /> : <span style={{ "display": "none" }}></span>}
            { showLoader && <Loader/>}
        </div>
    );
}

export default App;
